import { vi } from 'date-fns/locale'

const customViLocale = {
  ...vi,
  formatDistance: (token: string, count: number, options?: { addSuffix?: boolean }) => {
    const distanceLocale: Record<string, string> = {
      lessThanXSeconds: `${count} giây`,
      xSeconds: `${count} giây`,
      halfAMinute: 'nửa phút',
      lessThanXMinutes: `${count} phút`,
      xMinutes: `${count} phút`,
      aboutXHours: `Khoảng ${count} giờ`,
      xHours: `${count} giờ`,
      xDays: `${count} ngày`,
      aboutXWeeks: `Khoảng ${count} tuần`,
      xWeeks: `${count} tuần`,
      aboutXMonths: `Khoảng ${count} tháng`,
      xMonths: `${count} tháng`,
      aboutXYears: `Khoảng ${count} năm`,
      xYears: `${count} năm`,
      overXYears: `${count} năm`,
      almostXYears: `${count} năm`,
    }

    const result = distanceLocale[token] || ''
    if (options?.addSuffix) {
      return `${result} trước`
    }
    return result
  },
}

export default customViLocale
